import { Grid, Paper } from "@material-ui/core";
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import { Button, MenuItem, TextField } from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import dayjs from 'dayjs';
import "dayjs/locale/en-gb";
import { formatAmount, formatDate, SectionTitle, StyledTableCell, StyledTableRow } from "./SettlementDetailsShared";
import SettlementFilePreviewModal from "./SettlementFilePreviewModal";

const SettlementInformationSection = ({
  canUserActOnStatus,
  data,
  enableEdit,
  filePreview,
  handlePreviewClick,
  openPreview,
  setData,
  setOpenPreview,
  setUpdatedData,
  style,
  updatedData,
}) => (        <Grid item xs={12} md={6}>
          <SectionTitle>Settlement Information</SectionTitle>
          <TableContainer component={Paper} sx={{ marginBottom: 1, boxShadow: 0 }}>
            <Table size="small" sx={{ minWidth: 300 }}>
              <TableBody>
                <StyledTableRow>
                  <StyledTableCell variant="head">Issuer Name:</StyledTableCell>
                  <StyledTableCell>
                    {data.issuer?.name || "N/A"}
                    {/* {enableEdit && canUserActOnStatus(data.claimStatus) && (data.claimStatus === "Sent_Back" ) ? (
                      <Controller
                        name="issuerId"
                        control={control}
                        render={({ field }) => (
                          <Autocomplete
                            value={updatedData.issuerId ? issuerList.find((option) => option.id === updatedData.issuerId) ?? null : null}
                            disableClearable
                            getOptionLabel={(option) => `${option.name} (${option.tradecode})`}
                            onChange={(event, newValue) => {
                              setUpdatedData((prev) => ({ ...prev, issuerId: newValue ? newValue.id : "" }));
                              setData((prev) => ({ ...prev, issuer: { ...prev.issuer, name: newValue ? newValue.name : "" } }));
                            }}
                            options={issuerList}
                            renderInput={(params) => <TextField {...params} variant="standard" size="small" />}
                          />
                        )}
                      />
                    ) : (
                      data.issuer?.name || "N/A"
                    )} */}
                  </StyledTableCell>
                  <StyledTableCell variant="head">Dividend Type:</StyledTableCell>
                  <StyledTableCell>
                    {data.investorDividendType ? `${data.investorDividendType.dividendType} (${data.investorDividendType.investorDividendType})` : "N/A"}
                    {/* {enableEdit && canUserActOnStatus(data.claimStatus) && (data.claimStatus === "Sent_Back" ) ? (
                      <Controller
                        name="investorDividendTypeId"
                        control={control}
                        render={({ field }) => (
                          <Autocomplete
                            value={updatedData.investorDividendTypeId ? dividendType.find((option) => option.id === updatedData.investorDividendTypeId) ?? null : null}
                            disableClearable
                            getOptionLabel={(option) => `${option.investorDividendType} (${option.dividendType})`}
                            onChange={(event, newValue) => {
                              setUpdatedData((prev) => ({ ...prev, investorDividendTypeId: newValue ? newValue.id : "" }));
                              setData((prev) => ({ ...prev, investorDividendType: { ...prev.investorDividendType, investorDividendType: newValue ? newValue.investorDividendType : "", dividendType: newValue ? newValue.dividendType : "" } }));
                            }}
                            options={dividendType}
                            renderInput={(params) => <TextField {...params} variant="standard" size="small" />}
                          />
                        )}
                      />
                    ) : (
                      data.investorDividendType ? `${data.investorDividendType.dividendType} (${data.investorDividendType.investorDividendType})` : "N/A"
                    )} */}
                  </StyledTableCell>
                </StyledTableRow>
                <StyledTableRow>
                  <StyledTableCell variant="head">Claim By:</StyledTableCell>
                  <StyledTableCell>
                    {/* {data.claimType === 1 ? 'Self'  : data.claimType === 2 ? 'Authorized Person/Power of Attorney'  : data.claimType === 3 ? 'Successor/Nominee'  : "N/A"} */}
                    {enableEdit && canUserActOnStatus(data.claimStatus) && (data.claimStatus === "Sent_Back" ) ? (
                      <TextField
                        select
                        fullWidth
                        variant="standard"
                        size="small"
                        value={updatedData.claimType || ""}
                        onChange={(e) => {
                          setUpdatedData((prev) => ({ ...prev, claimType: e.target.value }));
                          setData((prev) => ({ ...prev, claimType: e.target.value }));
                        }}
                      >
                        <MenuItem value={1}>Self</MenuItem>
                        <MenuItem value={2}>Authorized Person/Power of Attorney</MenuItem>
                        <MenuItem value={3}>Successor/Nominee</MenuItem>
                      </TextField>
                    ) : (
                      data.claimType === 1 ? 'Self' : data.claimType === 2 ? 'Authorized Person/Power of Attorney' : data.claimType === 3 ? 'Successor/Nominee' : "N/A"
                    )}
                  </StyledTableCell>
                  <StyledTableCell variant="head">Account Type:</StyledTableCell>
                  <StyledTableCell>
                    {/* {data.accountType === 2 ? 'Individual Account' : data.accountType === 1 ? 'Joint Account'  : "N/A"} */}
                    {enableEdit && canUserActOnStatus(data.claimStatus) && (data.claimStatus === "Sent_Back" ) ? (
                      <TextField
                        select
                        fullWidth
                        variant="standard"
                        size="small"
                        value={updatedData.accountType || ""}
                        onChange={(e) => {
                          setUpdatedData((prev) => ({ ...prev, accountType: e.target.value }));
                          setData((prev) => ({ ...prev, accountType: e.target.value }));
                        }}
                      >
                        <MenuItem value={1}>Joint Account</MenuItem>
                        <MenuItem value={2}>Individual Account</MenuItem>
                      </TextField>
                    ) : (
                      data.accountType === 2 ? 'Individual Account' : data.accountType === 1 ? 'Joint Account' : "N/A"
                    )}
                  </StyledTableCell>
                </StyledTableRow>
                
                <StyledTableRow>
                  <StyledTableCell variant="head">Suspense:</StyledTableCell>
                  <StyledTableCell>
                    {/* {data.isSuspense === 0 ? 'No' : 'Yes'} */}
                    {enableEdit && canUserActOnStatus(data.claimStatus) && (data.claimStatus === "Sent_Back" ) ? (
                      <TextField
                        select
                        fullWidth
                        variant="standard"
                        size="small"
                        value={updatedData.isSuspense !== null ? updatedData.isSuspense : ""}
                        onChange={(e) => {
                          setUpdatedData((prev) => ({ ...prev, isSuspense: e.target.value }));
                          setData((prev) => ({ ...prev, isSuspense: e.target.value }));
                        }}
                      >
                        <MenuItem value={1}>Yes</MenuItem>
                        <MenuItem value={0}>No</MenuItem>
                      </TextField>
                    ) : (
                      data.isSuspense === 0 ? 'No' : 'Yes'
                    )}
                  </StyledTableCell>
                  <StyledTableCell variant="head">Dividend Status:</StyledTableCell>
                  <StyledTableCell>
                    {/* {data.dividendStatus === 0 ? 'Defined' : data.dividendStatus === 1 ? 'Undefined' : data.dividendStatus === 2 ? 'Defined Delisted' : data.dividendStatus === 3 ? 'Undefined Delisted' : 'N/A'} */}
                    {enableEdit && canUserActOnStatus(data.claimStatus) && (data.claimStatus === "Sent_Back" ) ? (
                      <TextField
                        select
                        fullWidth
                        variant="standard"
                        size="small"
                        value={updatedData.dividendStatus !== null ? updatedData.dividendStatus : ""}
                        onChange={(e) => {
                          setUpdatedData((prev) => ({ ...prev, dividendStatus: e.target.value }));
                          setData((prev) => ({ ...prev, dividendStatus: e.target.value }));
                        }}
                      >
                        <MenuItem value={0}>Defined</MenuItem>
                        <MenuItem value={1}>Undefined</MenuItem>
                        <MenuItem value={2}>Defined Delisted</MenuItem>
                        <MenuItem value={3}>Undefined Delisted</MenuItem>
                      </TextField>
                    ) : (
                      data.dividendStatus === 0 ? 'Defined' : data.dividendStatus === 1 ? 'Undefined' : data.dividendStatus === 2 ? 'Defined Delisted' : data.dividendStatus === 3 ? 'Undefined Delisted' : 'N/A'
                    )}
                  </StyledTableCell>
                </StyledTableRow>

                <StyledTableRow>
                  <StyledTableCell variant="head">Application Date:</StyledTableCell>
                  <StyledTableCell>
                    {/* {formatDate(data.applicationDate)} */}
                    {enableEdit && canUserActOnStatus(data.claimStatus) && (data.claimStatus === "Sent_Back" ) ? (
                      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={'en-gb'}>
                        <DatePicker
                          disableFuture
                          value={updatedData.applicationDate ? dayjs(updatedData.applicationDate) : null}
                          onChange={(date) => {
                            const formattedDate = date ? date.format("YYYY/MM/DD") : "";
                            setUpdatedData((prev) => ({ ...prev, applicationDate: formattedDate }));
                            setData((prev) => ({ ...prev, applicationDate: formattedDate }));
                          }}
                          renderInput={(params) => <TextField {...params} variant="standard" size="small" fullWidth />}
                        />
                      </LocalizationProvider>
                    ) : (
                      formatDate(data.applicationDate)
                    )}
                  </StyledTableCell>
                  <StyledTableCell variant="head">Received Date:</StyledTableCell>
                  <StyledTableCell>
                    {/* {formatDate(data.receiveDate)} */}
                    {enableEdit && canUserActOnStatus(data.claimStatus) && (data.claimStatus === "Sent_Back" ) ? (
                      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={'en-gb'}>
                        <DatePicker
                          disableFuture
                          value={updatedData.receiveDate ? dayjs(updatedData.receiveDate) : null}
                          onChange={(date) => {
                            const formattedDate = date ? date.format("YYYY/MM/DD") : "";
                            setUpdatedData((prev) => ({ ...prev, receiveDate: formattedDate }));
                            setData((prev) => ({ ...prev, receiveDate: formattedDate }));
                          }}
                          renderInput={(params) => <TextField {...params} variant="standard" size="small" fullWidth />}
                        />
                      </LocalizationProvider>
                    ) : (
                      formatDate(data.receiveDate)
                    )}
                  </StyledTableCell>
                </StyledTableRow>

                <StyledTableRow>
                  
                  <StyledTableCell variant="head">Total Amount:</StyledTableCell>
                  <StyledTableCell>{formatAmount(data.totalAmount)}</StyledTableCell>
                  <StyledTableCell variant="head">Total Suspense Amount:</StyledTableCell>
                  <StyledTableCell>{formatAmount(data.totalSuspenseAmount)}</StyledTableCell>
                </StyledTableRow>
                
                <StyledTableRow>
                  <StyledTableCell variant="head">Claim Status:</StyledTableCell>
                  <StyledTableCell>{data.claimStatus}</StyledTableCell>
                  <StyledTableCell variant="head">Remarks:</StyledTableCell>
                  <StyledTableCell>
                    {/* {data.remarks} */}
                    {enableEdit && canUserActOnStatus(data.claimStatus) && (data.claimStatus === "Sent_Back" ) ? (
                      <TextField
                        fullWidth
                        variant="standard"
                        size="small"
                        value={updatedData.remarks || ""}
                        onChange={(e) => {
                          setUpdatedData((prev) => ({ ...prev, remarks: e.target.value }));
                          setData((prev) => ({ ...prev, remarks: e.target.value }));
                        }}
                      />
                    ) : (
                      data.remarks
                    )}
                  </StyledTableCell>
                </StyledTableRow>
                <StyledTableRow>
                  <StyledTableCell colSpan={4} align="right">
                    <>
                    <Button variant="contained" size="small" style={{margin:"5px"}} color="primary" onClick={handlePreviewClick}>
                     <RemoveRedEyeIcon/> View File
                    </Button>
                    <SettlementFilePreviewModal
                      filePreview={filePreview}
                      onClose={() => setOpenPreview(false)}
                      open={openPreview}
                      style={style}
                    />
                  </>
                  </StyledTableCell>
                </StyledTableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>);

export default SettlementInformationSection;
